import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  wrapperDialog: {
    textAlign: "center"
  },
  wrapperDialog2: {
    textAlign: "left"
  },
  wrapperDialogClose: {
    position: "absolute",
    right: 5,
    top: 5
  },
  iconDialog: {
    color: "#747474",
    width: 44,
    height: 44,
    marginBottom: 5
  },
  iconSuccessDialog: {
    color: "#328914",
    width: 44,
    height: 44,
    marginBottom: 5
  },
  iconErrorDialog: {
    color: "#0b417e",
    width: 44,
    height: 44,
    marginBottom: 5
  },
  itemHeader: {
    fontWeight: "bold"
  },
  iconsDialogClose: {
    color: "#979797",
    width: 20,
    height: 20
  },
  titleDialog: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 5
  },
  titleDialog2: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 5,
    textAlign: "center"
  },
  contentDialog: {
    fontSize: 14
  },
  wrapperDialogAction: {
    textAlign: "center",
    justifyContent: "center !important",
    marginBottom: 20
  },
  wrapperDialogAction2: {
    textAlign: "right",
    marginBottom: 20
  },
  button: {
    textTransform: "Capitalize",
    paddingLeft: 50,
    paddingRight: 50,
    marginLeft: 10,
    fontWeight: "bold",
    backgroundColor: "#4f98bc",
    "&:hover": {
      backgroundColor: "#4f98bc"
    }
  },
  buttonOutlined: {
    textTransform: "Capitalize",
    paddingLeft: 50,
    paddingRight: 50,
    color: "#4f98bc",
    marginRight: 40
  },
  button2: {
    textTransform: "Capitalize",
    paddingLeft: 50,
    paddingRight: 50,
    marginLeft: 10,
    marginRight: 16,
    fontWeight: "bold",
    backgroundColor: "#4f98bc",
    "&:hover": {
      backgroundColor: "#4f98bc"
    }
  },
  buttonOutlined2: {
    textTransform: "Capitalize",
    paddingLeft: 50,
    paddingRight: 50,
    color: "#4f98bc",
    marginRight: 10
  },
  formContainer: {
    paddingLeft: 50,
    paddingRight: 50,
    paddingTop: 20,
    paddingBottom: 20
  },
  checkbox: {
    color: "#ececec"
  },
  labelCheckbox: {
    "& > span.MuiTypography-root": {
      color: "#4d4d4d",
      fontSize: 12
    }
  },
  itemDialog: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  },
  itemDialogTitle: {
    paddingLeft: 8
  },
  itemDialog2: {},
  titleDialog3: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#16457a"
  },
  customInputInternalLabel: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#16457a",
    marginTop: 8
  },
  taskItem2: {
    marginTop: 22
  },
  labelTip: {
    fontSize: 14
  },
  headLabel: {
    fontWeight: "bold",
    paddingBottom: "6px !important",
    whiteSpace: "nowrap"
  },
  tablecell: {
    padding: "2px 5px 2px 2px !important"
  },
  tablerow: {
    height: 43,
    transition: "0.2s ease-in",
    cursor: "auto",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.02) !important",
      "& $viewAction": {
        visibility: "visible"
      }
    },
    "& > td": {
      borderBottom: "solid 1px rgba(0, 0, 0, 0.05)"
    }
  },
  itemContainer: {
    marginTop: theme.spacing(4)
  }
}));

export default useStyles;
